import React from "react";
import { Drawer } from "@material-ui/core";

import RecourseSchedule from "./RecourseSchedule";

export default class RecourseScheduleDrawer extends React.Component {
  render() {
    const { open, ...other } = this.props;

    return (
      <Drawer
        id="recourseScheduleDrawer"
        onClose={this.props.onClose}
        anchor="right"
        open={open}
        style={{ minWidth: "1000px", maxWidth: "1000px", width: "50%" }}
      >
        <RecourseSchedule
          {...other}
        />
      </Drawer>
    );
  }
}
